import { render, staticRenderFns } from "./RatioChart.vue?vue&type=template&id=8da9d5e2&"
import script from "./RatioChart.vue?vue&type=script&lang=js&"
export * from "./RatioChart.vue?vue&type=script&lang=js&"
import style0 from "./RatioChart.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports